import { defineAbility } from '@casl/ability'

import { User } from '../../models'
import { Roles, userHasRole } from '../../helpers'

export default (user: User) => defineAbility((can) => {
    if (userHasRole(user, Roles.SrLead)) {
        can('Edit', 'Agency')
        can('Upload', 'AgencyData')
        can('Edit', 'AgencyStatus')
        can('Delete', 'AgencyNote')
        can('Edit', 'AgencyBookingSoftware')
        can('Create', 'AgencyArc')
        can('Create', 'Agency')
    }

    if (userHasRole(user, Roles.Standard)) {
        can('View', 'Agency')
        can('Update', 'AgencyNote')
    }

    if (userHasRole(user, Roles.Accounting)) {
        can('Create', 'AgencyPayment')
    }
})
